import { render } from "./PerformanceBenchmarking.vue?vue&type=template&id=0315f41e&scoped=true"
import script from "./PerformanceBenchmarking.vue?vue&type=script&lang=js"
export * from "./PerformanceBenchmarking.vue?vue&type=script&lang=js"

import "./PerformanceBenchmarking.vue?vue&type=style&index=0&id=0315f41e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0315f41e"]])

export default __exports__